import React, { useEffect, useState, useContext } from "react"
import {PrimaryCard, WarningCard } from "../../components/cards";
import productShortName from "../../../../utils/GetProductShortName";
import useIsMounted from "../../../../hooks/useIsMounted";
import { CurrencyLabel } from "../../../common/inputs";
import useApi from '../../../../hooks/useApi';
import widgetService from "../../../../services/invTransactions";
import EntityContext from "../../../../context/entityContext";

export default function AdvancedSummary({ reloadKey = 0 }){

    const isMounted = useIsMounted();
    const { selectedBusinessType, selProduct, entityDetails } = useContext(EntityContext);
    const [data, setData] = useState(null);

    //------------Api Services-----------------------------------
    const approvedInvoicesApi = useApi(widgetService.getAdvancedSummary);
    
    const fetchApprovedInvoices = async () => {
        const response = await approvedInvoicesApi.request({ entity_id: entityDetails.a_guid, selectedBusinessType });
        const summary = response?.data;
        if(summary && isMounted()){
            setData({
                topLabel: "Advanced",
                topValue: <CurrencyLabel decimal={2} value={summary.total_inv_amt} />,
                leftLabel: summary.isPrimary ? "Debtors" : "Clients",
                leftValue: summary.isPrimary ? summary.debtor_count : summary.client_count,
                rightLabel: "Invoices",
                rightValue: summary.invoice_count,
                bottomRightLabel: "",
                primaryBtnRoute: `/client/${productShortName(selProduct)}/sale-invoices?status=open`
            })
        }
    }

    useEffect(() => {
        fetchApprovedInvoices();
    }, [selectedBusinessType, entityDetails, reloadKey])

    return(
        <>
            <PrimaryCard
                loading={approvedInvoicesApi.loading}
                data={data}
                qrystring={true}
            />
        </>
    )
}